import React from 'react';
import Navigation from './Navigation'

export default function Layout() {
  return (
    <div>
      <h1>My GitHub Portfolio</h1>
      <Navigation />
    </div>
  )
}